<template>
	<div style="margin: 10px;">

		<!-- 全屏透明的loading加载start -->
		<div id="pageLoading" v-if="loading" style="position: fixed;top:0;left: 0;width: 100%;height: 100%;display: flex;justify-content: center;align-items: center;z-index: 999999;">
			<i class="el-icon-loading" style="font-size: 25px;"></i>
		</div>
		<!-- 全屏透明的loading加载end -->

		<div style="background-color: #fff;border-radius: 3px;">
			<div style="position: sticky;top:0;z-index: 999;background-color: #fff;">

				<!--带折叠的搜索start-->
				<div style="padding-bottom: 10px;padding-top: 10px;">
					<el-form size="mini" style="display: flex;flex-wrap: wrap;" ref="searchForm" :model="searchForm" inline :label-width="isMobile?'200px':'100px'">

						<!--收起时显示的搜索项start  4个搜索项为一行-->
						<div v-show="!isShowCollapse" style="width: 80%;display: flex;">
							<el-form-item label="手机号" style="width: 23%;display: flex;">
								<el-input type="text" v-model="searchForm.mobile" placeholder="输入手机号" clearable />
							</el-form-item>
							<el-form-item v-if="role=='hq_admin'" label="门店" style="width: 23%;display: flex;">
								<el-select v-model="searchForm.store_id" clearable placeholder="请选择">
									<el-option v-for="(item,index) in storeList" :label="item.name" :value="item.id" />
								</el-select>
							</el-form-item>



							<el-form-item label="订单状态" style="width: 23%;display: flex;">
								<el-select v-model="searchForm.order_status" placeholder="选择订单状态" clearable @change="statusChange">
									<!-- 订单状态 (0: 待付款, 1: 已付款, 2: 已完成, 3: 已取消, 4: 已关闭) -->

									<el-option :value="1" label="待发货"></el-option>
									<el-option :value="2" label="待收货"></el-option>
									<el-option :value="3" label="已完成"></el-option>
									<el-option :value="4" label="退货申请"></el-option>


								</el-select>
							</el-form-item>

							<el-form-item v-if="!isMobile" label="快递类型" style="width: 23%;display: flex;" label-width="120px">
								<el-select multiple v-model="searchForm.express_type" placeholder="选择快递类型" clearable>
									<!-- 2: 到付, 3: 包邮, 4: 自提, 5: 闪送-->
									<el-option :value="1" label="在线支付"></el-option>
									<el-option :value="2" label="到付"></el-option>
									<el-option :value="3" label="包邮"></el-option>
									<el-option :value="4" label="自提"></el-option>
									<el-option :value="5" label="闪送"></el-option>
									<el-option :value="6" label="邮寄"></el-option>
								</el-select>
							</el-form-item>
							
							<el-form-item v-if="!isMobile&&(role=='store_admin'||role=='store_sa')" label="课时状态" style="width: 23%;display: flex;" label-width="120px">
								<el-select v-model="searchForm.course_status" placeholder="选择课时状态" clearable>
									<!-- 0: 未扣除, 1: 已扣除, 2: 已退回 -->
							
									<el-option :value="0" label="未扣除"></el-option>
									<el-option :value="1" label="已扣除"></el-option>
							
								</el-select>
							</el-form-item>


						</div>
						<!--收起时显示的搜索项end-->

						<!--展开时显示的搜索项start  4个搜索项为一行-->
						<div v-if="isShowCollapse" style="display: flex;flex-wrap: wrap;">

							<el-form-item label="手机号" style="width: 23%;display: flex;" label-width="120px">
								<el-input type="text" v-model="searchForm.mobile" placeholder="输入手机号" clearable />
							</el-form-item>
							<el-form-item v-if="role=='hq_admin'" label="门店" style="width: 23%;display: flex;" label-width="120px">
								<el-select v-model="searchForm.store_id" clearable placeholder="请选择">
									<el-option v-for="(item,index) in storeList" :label="item.name" :value="item.id" />
								</el-select>
							</el-form-item>



							<el-form-item label="订单状态" style="width: 23%;display: flex;" label-width="120px">
								<el-select v-model="searchForm.order_status" placeholder="选择订单状态" clearable>
									<!-- 订单状态 (1: 待发货, 2: 待收货, 3: 已完成, 4: 已退货) -->

									<el-option :value="1" label="待发货"></el-option>
									<el-option :value="2" label="待收货"></el-option>
									<el-option :value="3" label="已完成"></el-option>
									<el-option :value="4" label="退货申请"></el-option>

								</el-select>
							</el-form-item>

							<el-form-item label="快递类型" style="width: 23%;display: flex;" label-width="120px">
								<el-select multiple v-model="searchForm.express_type" placeholder="选择快递类型" clearable>
									<!-- 2: 到付, 3: 包邮, 4: 自提, 5: 闪送-->
									<el-option :value="1" label="在线支付"></el-option>
									<el-option :value="2" label="到付"></el-option>
									<el-option :value="3" label="包邮"></el-option>
									<el-option :value="4" label="自提"></el-option>
									<el-option :value="5" label="闪送"></el-option>
									<el-option :value="6" label="邮寄"></el-option>
								</el-select>
							</el-form-item>

							<el-form-item label="课时状态" style="width: 23%;display: flex;" label-width="120px">
								<el-select v-model="searchForm.course_status" placeholder="选择课时状态" clearable>
									<!-- 0: 未扣除, 1: 已扣除, 2: 已退回 -->

									<el-option :value="0" label="未扣除"></el-option>
									<el-option :value="1" label="已扣除"></el-option>

								</el-select>
							</el-form-item>





							<el-form-item label="门店补款状态" style="width: 23%;display: flex;" label-width="120px">
								<el-select v-model="searchForm.repayment_status" placeholder="选择课时状态" clearable>
									<!-- 0: 未补款, 1: 已补款, 2: 已退回 -->

									<el-option :value="0" label="未补款"></el-option>
									<el-option :value="1" label="已补款"></el-option>
									<el-option :value="2" label="已退回"></el-option>
									<el-option :value="3" label="无需操作"></el-option>
									<el-option :value="4" label="已确认"></el-option>
								</el-select>
							</el-form-item>

							<el-form-item label="门店返现状态" style="width: 23%;display: flex;" label-width="120px">
								<el-select v-model="searchForm.bounty_status" placeholder="选择门店返现状态" clearable>
									<!-- 0: 未发放, 1: 已发放 -->

									<el-option :value="0" label="未返现"></el-option>
									<el-option :value="1" label="已返现"></el-option>

								</el-select>
							</el-form-item>

							<el-form-item label="发票状态" style="width: 23%;display: flex;" label-width="120px">
								<el-select v-model="searchForm.invoice_status" placeholder="选择课时状态" clearable @change="invoiceChange">
									<!-- 0: 无需发票, 1: 申请电子发票, 2: 已开票-->

									<el-option :value="0" label="无需发票"></el-option>
									<el-option :value="1" label="申请发票"></el-option>
									<el-option :value="2" label="已开票"></el-option>
								</el-select>
							</el-form-item>

							<el-form-item label="订单编号" style="width: 23%;display: flex;" label-width="120px">
								<el-input type="text" v-model="searchForm.order_code" placeholder="输入订单编号" clearable />
							</el-form-item>

							<el-form-item label="商品类型" style="width: 23%;display: flex;" label-width="120px">
								<el-select v-model="searchForm.activity_type" placeholder="选择商品类型" clearable>
									<!--  	商品类型 (0: 普通商品, 1: 卡券商品, 3: 课时商品, 4: 课时活动)-->

									<el-option :value="0" label="普通商品"></el-option>
									<el-option :value="1" label="卡券商品"></el-option>
									<el-option :value="3" label="课时商品"></el-option>
									<el-option :value="4" label="课时活动"></el-option>
									<el-option :value="5" label="体验课程"></el-option>
								</el-select>
							</el-form-item>

							<el-form-item label="角色" style="width: 23%;display: flex;" label-width="120px">
								<el-select v-model="searchForm.role" placeholder="选择角色" clearable>


									<el-option :value="0" label="大众用户"></el-option>
									<el-option :value="1" label="会员用户"></el-option>
									<el-option :value="2" label="城代用户"></el-option>
									<el-option :value="3" label="供货用户"></el-option>
								</el-select>
							</el-form-item>

							<el-form-item label="日期" style="width: 40%;display: flex;">
								<div slot="label" style="width: 95px;text-align: right;">日期</div>
								<el-date-picker style="margin-left: 8px;" v-model="searchForm.date" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
							</el-form-item>

							<!-- <el-form-item label="更新时间排序" prop="updateTimeOrder" label-width="120px" style="width: 23%;">
								<el-select v-model="searchForm.updateTimeOrder" clearable>
									<el-option value="asc">正序</el-option>
									<el-option value="desc">倒序</el-option>
								</el-select>
							</el-form-item> -->




						</div>
						<!--展开时显示的搜索项end-->

						<div :style="{'padding-right':isShowCollapse?'15px':'0','width':isShowCollapse?'100%':'20%','justify-content': isShowCollapse?'flex-end':'center' }" style="height: 30px; display: flex;margin: 0;">
							<div style="flex-shrink: 0;margin-right: 20px;display: flex;justify-content: center;align-items: center;cursor:pointer;color: rgb(154, 126, 156);font-size: 14px;line-height: 20px; display: flex;margin-left: 20px;" @click="isShowCollapseF()">
								<span v-if="!isShowCollapse">展开</span>
								<span v-else>收起</span>
								<span style="margin-left: 5px;font-size: 20px;line-height: 20px;" :style="{transform:isShowCollapse?'rotate(180deg)':'rotate(0deg)'}">∨</span>
							</div>
							<el-button round size="small" style="margin-right: 10px" @click="handleSearch" type="primary" icon="ios-search">搜索</el-button>
							<el-button round size="small" @click="handleReset" :style="{'margin-right': isShowCollapse?'10px':'28px'}">重置</el-button>
						</div>

					</el-form>
				</div>
				<!--带折叠的搜索end-->




			</div>

			<div>
				<div style="display: flex;justify-content: space-between;position: relative;z-index: 9;padding-left: 30px;">

					<div v-if="role=='hq_admin'" style="display: flex;align-items: center;color: #666;font-size: 14px;">

						<div>商品销售金额: {{price.goods_price}}</div>
						<div style="margin-left: 30px;">商品供货金额: {{price.supply_price}}</div>
						<div style="margin-left: 30px;">用户支付金额: {{price.payment_price}}</div>
						<div style="margin-left: 30px;">门店补款金额: {{price.repayment_price}}</div>
						<div style="margin-left: 30px;">门店返现金额: {{price.bounty_price}}</div>



					</div>
					<div>
						<el-button v-if="role=='hq_admin'" round size="small" type="success" @click="showFanXianModal" style="margin-right: 20px;">门店返现</el-button>
						<el-button round size="small" type="primary" @click="exportXFnByHTML" style="margin-right: 25px;">订单导出</el-button>
					</div>

					<!-- <el-button round size="small" type="primary" @click="exportXFn()" style="margin-right: 20px;margin-left: 0;">导出发货订单</el-button>
					<el-upload action="" :before-upload="handleBeforeUpload" :show-upload-list="false" accept=".xls, .xlsx">
						<el-button round size="small" type="warning" style="margin-right: 20px;">导入物流单号</el-button>
					</el-upload> -->

				</div>



				<el-table :height="tableHeight" style="margin-top: -35px;" @selection-change="handleSelect" ref="tablesi" :data="tableData" @on-delete="handleDelete">
					<!-- 多选框 <el-table-column type="selection" width="40">
					</el-table-column> -->

					<el-table-column style="width: 100%;">
						<template slot-scope="{ row, index }">

							<div class="titleFont" style="font-size: 10px;color: rgb(51, 51, 51);text-align: left;padding-left: 20px;background-color: #f8f8f8;padding-top: 5px;padding-bottom: 5px;border-radius: 20px;">


								<!-- 
			订单流程：
			下单->发货->收货完成
			下单->退款->同意退款->提交退货物流->确认退款
			下单->退款->拒绝退款
			下单->发货->确认收货->退款->同意退款->提交退货物流->确认退款
			下单->发货->确认收货->退款->拒绝退款
		 -->

								<span>订单状态:</span>
								<!-- (0: 待付款, 1: 已付款, 2: 已完成, 3: 已取消, 4: 已关闭) -->
								
								<span v-if="row.order_status ==0" style="margin-left: 6px;color: #2d8cf0;font-weight: bold;">待付款</span>


								<!-- <span v-else-if="row.status ==1&&row.express_type==4" style="margin-left: 6px;color: #2d8cf0;font-weight: bold;">待自提</span>
								<span v-else-if="row.status ==1&&row.express_type==5" style="margin-left: 6px;color: #2d8cf0;font-weight: bold;">待闪送</span>
								 -->

								<span v-else-if="row.order_status ==1" style="margin-left: 6px;color: #2d8cf0;font-weight: bold;">已付款</span>
								<span v-else-if="row.order_status ==2" style="margin-left: 6px;color: limegreen;font-weight: bold;">已完成</span>
								<span v-else-if="row.order_status ==3" style="margin-left: 6px;color: red;font-weight: bold;">已取消</span>
								<span v-else-if="row.order_status ==4" style="margin-left: 6px;color: red;font-weight: bold;">已关闭</span>


								<span style="margin-left: 50px;">订单编号:</span><span style="margin-left: 6px;">{{row.order_code}}</span>
								<span style="margin-left: 50px;">id:</span><span style="margin-left: 6px;">{{row.id}}</span>
								<!-- <span v-if="row.express_num" style="margin-left: 50px;">快递单号:</span><span style="margin-left: 6px;">{{row.express_num}}</span>

								<span v-if="row.express_time" style="margin-left: 50px;">发货时间:</span><span style="margin-left: 6px;">{{row.express_time}}</span>
 -->
								<span style="margin-left: 50px;">创建时间:</span><span style="margin-left: 6px;">{{row.created_at}}</span>

							</div>

							<div class="tableTem" style="display: flex;align-items: center;margin-left: 20px;margin-bottom: 10px;">
								<div class="avatar" style="padding-top: 15px;">

									<!-- 商品start -->
									<div style="width: 300px;padding-right: 10px;max-height: 180px;overflow-y: auto;">
										<!-- .slice(0,2) -->
										<div v-for="(item,index) in row.goods" :key="index" style="margin: 0px 3px;margin-top: 10px;  display: flex;justify-content: space-between;">
											<div style="width: 200px;color: #333333;">
												<div style="display: flex;">
													<img :src="item.image" style="width: 60px;height: 60px;margin-right: 5px;border-radius: 5px;cursor: pointer;" @click="handlePreView(item.image)" />
													<div style="text-align: left;">
														<div style="font-size: 12px;margin-right: 10px;line-height: 15px;margin-bottom: 6px;">
															<el-tooltip :content="item.name" placement="right">
																<div style="width: 140px;overflow: hidden;text-overflow: ellipsis;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;">{{item.name}}</div>

															</el-tooltip>
														</div>
														<div style="font-size: 10px;line-height: 14px;margin-right: 10px;color: #888;">{{item.specs_value_str}}</div>
													</div>
												</div>

											</div>

											<div style="text-align: right;font-size: 13px;color: #888;">
												<div>

													<!-- 状态 (0: 待付款, 1: 待发货, 2: 待收货, 3: 已完成, 4: 已取消, 5: 申请退款, 6: 退货中, 7: 退货完成) -->
													<span v-if="item.status==0" style="font-size: 12px;color:rgb(45, 140, 240);font-weight:bold;">待付款</span>
													<span v-else-if="item.status==1&&row.express_type==4&&(row.activity_type==1||row.activity_type==0||row.activity_type==3)" style="font-size: 12px;color:rgb(45, 140, 240);font-weight:bold;">待自提</span>
													<span v-else-if="item.status==1&&row.express_type==4&&(row.activity_type==5)" style="font-size: 12px;color:rgb(45, 140, 240);font-weight:bold;">待体验</span>
													<span v-else-if="item.status==1&&row.express_type==4&&row.activity_type==4" style="font-size: 12px;color:rgb(45, 140, 240);font-weight:bold;">待核销</span>
													
													<span v-else-if="item.status==1&&row.express_type==5" style="font-size: 12px;color:rgb(45, 140, 240);font-weight:bold;">待闪送</span>
													
													<span v-else-if="item.status==1" style="font-size: 12px;color:rgb(45, 140, 240);font-weight:bold;">待发货</span>
													<span v-else-if="item.status==2" style="font-size: 12px;color:rgb(45, 140, 240);font-weight:bold;">待收货</span>
													<span v-else-if="item.status==3" style="font-size: 12px;color:limegreen;font-weight:bold;">已完成</span>
													<span v-else-if="item.status==4" style="font-size: 12px;color:rgb(45, 140, 240);font-weight:bold;">已取消</span>
													<span v-else-if="item.status==5" style="font-size: 12px;color:red;font-weight:bold;">申请退款</span>
													<span v-else-if="item.status==6" style="font-size: 12px;color:red;font-weight:bold;">退货中</span>
													<span v-else-if="item.status==7" style="font-size: 12px;color:limegreen;font-weight:bold;">退货完成</span>
												</div>
												<div>
													{{item.count}}件
												</div>
											</div>
										</div>
										<!-- <div v-if="row.goods.length>2" style="text-align: right;">
												<span @click="showOrderDetailModal(row)" style="font-size: 13px;color:#FF7D50;cursor: pointer;">查看更多 ></span>
											</div> -->

									</div>
									<!-- 商品end -->



									<div style="width: 150px;border-right: 1px solid #ededed;color: rgb(51, 51, 51);margin-left: 10px;">
										
										<div class="titleFont" style="text-align: left;">
											<span style="margin-right: 5px;">订单金额:</span>
											<el-tooltip :content="row.order_price+''" placement="right"><span class="content">¥{{row.order_price}}</span></el-tooltip>
										</div>
										
										<div class="titleFont" style="text-align: left;">
											<span style="margin-right: 5px;">积分金额:</span>
											<el-tooltip :content="row.credit_price+''" placement="right"><span class="content">¥{{row.credit_price}}</span></el-tooltip>
										</div>
										
										<div class="titleFont" style="text-align: left;">
											<span style="margin-right: 5px;">商品金额:</span>
											<el-tooltip :content="row.goods_price+''" placement="right"><span class="content">¥{{row.goods_price}}</span></el-tooltip>
										</div>
										
										
										
										<div class="titleFont" style="text-align: left;">
											<span style="margin-right: 5px;">供货金额:</span>
											<el-tooltip :content="row.supply_price+''" placement="right"><span class="content">¥{{row.supply_price}}</span></el-tooltip>
										</div>
										

										




										<div class="titleFont" style="text-align: left;">
											<span style="margin-right: 5px;">付款金额:</span>
											<el-tooltip :content="row.payment_price+''" placement="right"><span class="content">¥{{row.payment_price}}</span></el-tooltip>
										</div>



										<div class="titleFont" style="text-align: left;">
											<span style="margin-right: 5px;">手机号:</span>
											<el-tooltip :content="row.user?row.user.mobile+'':''" placement="right"><span class="content">{{row.user?row.user.mobile+'':''}}</span></el-tooltip>
										</div>

										<div class="titleFont" style="text-align: left;">
											<span style="margin-right: 5px;">快递类型:</span>
											<!-- 
												快递类型 (1: 已付, 2: 到付, 3: 包邮, 4: 自提, 5: 闪送, 6: 邮寄)
											 -->

											<el-tooltip v-if="row.express_type==1" content="已在线支付" placement="right"><span class="content">已在线支付</span></el-tooltip>
											<el-tooltip v-if="row.express_type==2" content="到付" placement="right"><span class="content">到付</span></el-tooltip>
											<el-tooltip v-if="row.express_type==3" content="包邮" placement="right"><span class="content">包邮</span></el-tooltip>
											
											<el-tooltip v-if="row.express_type==4&&row.activity_type==4" content="核销" placement="right"><span class="content">核销</span></el-tooltip>
											<el-tooltip v-else-if="row.express_type==4&&row.activity_type==5" content="核销" placement="right"><span class="content">核销</span></el-tooltip>
											<el-tooltip v-else-if="row.express_type==4" content="自提" placement="right"><span class="content">自提</span></el-tooltip>
											
											<el-tooltip v-if="row.express_type==5" content="闪送" placement="right"><span class="content">闪送</span></el-tooltip>
											<el-tooltip v-if="row.express_type==6" content="邮寄" placement="right"><span class="content">邮寄</span></el-tooltip>


										</div>

										<div class="titleFont" style="text-align: left;">
											<span style="margin-right: 5px;">商品类型:</span>
											<!-- 0: 普通商品, 1: 卡券商品) -->
											<el-tooltip v-if="row.activity_type==0" content="普通商品" placement="right"><span class="content">普通商品</span></el-tooltip>
											<el-tooltip v-if="row.activity_type==1" content="卡券商品" placement="right"><span class="content">卡券商品</span></el-tooltip>
											<el-tooltip v-if="row.activity_type==3" content="课时商品" placement="right"><span class="content">课时商品</span></el-tooltip>
											<el-tooltip v-if="row.activity_type==4" content="课时活动" placement="right"><span class="content">课时活动</span></el-tooltip>
											<el-tooltip v-if="row.activity_type==5" content="体验课程" placement="right"><span class="content">体验课程</span></el-tooltip>
											

										</div>

										<!-- <div v-if="row.activity_type==1" class="titleFont" style="text-align: left;">
											<span style="margin-right: 5px;">预约时间:</span>
											
											<el-tooltip :content="row.create_date+''" placement="right"><span class="content">{{row.create_date}}</span></el-tooltip>
											
										</div> -->




									</div>


								</div>

								<ul :style="{'width':isMobile?mobileWidth+'px':'','overflow-x':isMobile?'auto':'','overflow-y':isMobile?'hidden':'','flex-wrap':isMobile?'nowrap':''}">


									<!-- <li style="border-left: none;">
										<div class="content">
											<el-tooltip :content="row.express_price+''" placement="right">
												<div class="dian">{{row.express_price}}</div>
											</el-tooltip>
										</div>
										<div class="titleFont">运费金额</div>
									</li> -->

									<li>
										<div class="content">
											<el-tooltip :content="row.store?row.store.name+'':'无'" placement="right">
												<div class="dian">{{row.store?row.store.name:'无'}}</div>
											</el-tooltip>
										</div>
										<div class="titleFont">门店名称</div>
									</li>

									<li>
										<div class="content">
											<el-tooltip :content="row.course_code?row.course_code+'':'无'" placement="right">
												<div class="dian">{{row.course_code?row.course_code:'无'}}</div>
											</el-tooltip>
										</div>
										<div class="titleFont">课时合同</div>
									</li>

									<li>
										<div class="content">
											<el-tooltip :content="row.course_price?row.course_price+'':'无'" placement="right">
												<div class="dian">{{row.course_price?row.course_price:'无'}}</div>
											</el-tooltip>
										</div>
										<div class="titleFont">课时总价</div>
									</li>

									<li>
										<div class="content">
											<el-tooltip :content="row.course_count+''" placement="right">
												<div class="dian">{{row.course_count}}</div>
											</el-tooltip>
										</div>
										<div class="titleFont">课时数量</div>
									</li>



									<li>
										<div class="content">
											<!-- 0: 未扣除, 1: 已扣除, 2: 已退回 3.无需扣除-->
											<span v-if="row.course_status ==0">未扣除</span>
											<span v-else-if="row.course_status ==1">已扣除</span>
                      <span v-else-if="row.course_status ==2">已退回</span>
											<span v-else-if="row.course_status ==3">无需操作</span>
										</div>
										<div class="titleFont dian">课时状态</div>
									</li>

									<li>
										<div class="content">
											<el-tooltip :content="row.repayment_price+''" placement="right">
												<div class="dian">{{row.repayment_price}}</div>
											</el-tooltip>
										</div>
										<div class="titleFont">补款金额</div>
									</li>

									<li>
										<div class="content">
											<!-- 0: 未补款, 1: 已补款, 2: 已退回 3.repayment_status 无需补款-->

											<span v-if="row.repayment_status ==0">未补款</span>
											<span v-else-if="row.repayment_status ==1">已补款</span>
											<span v-else-if="row.repayment_status ==2">已退回</span>
											<span v-else-if="row.repayment_status ==3">无需操作</span>
											<span v-else-if="row.repayment_status ==4">已确认</span>
										</div>
										<div class="titleFont dian">补款状态</div>
									</li>


									<li>
										<div class="content">
											<el-tooltip :content="row.bounty_price+''" placement="right">
												<div class="dian">{{row.bounty_price}}</div>
											</el-tooltip>
										</div>
										<div class="titleFont">返现金额</div>
									</li>

									<li>
										<div class="content">

											<!-- 0: 未发放, 1: 已发放 3.无需返现-->
											<span v-if="row.bounty_status ==0">未发放</span>
											<span v-else-if="row.bounty_status ==1">已发放</span>
											<span v-else-if="row.bounty_status ==3">无需操作</span>
										</div>
										<div class="titleFont dian">返现状态</div>
									</li>


									<li>
										<div class="content">
											<!-- 0: 无需发票, 1: 申请电子发票, 2: 已开票 -->
											<div v-if="row.invoice_status==0" class="dian">无需发票</div>
											<div v-if="row.invoice_status==1" class="dian">申请发票</div>
											<div v-if="row.invoice_status==2" class="dian">已开票</div>
										</div>
										<div class="titleFont">发票状态</div>
									</li>
									
									<li>
										<div class="content">
											<!-- 角色 (0: 大众, 1: 会员, 2: 城代) -->
											<div v-if="row.role==0" class="dian">大众</div>
											<div v-if="row.role==1" class="dian">会员</div>
											<div v-if="row.role==2" class="dian">城代</div>
											<div v-if="row.role==3" class="dian">供货</div>
										</div>
										<div class="titleFont">用户角色</div>
									</li>
									<li>
										<div class="content">
											<el-tooltip :content="row.user&&row.user.etm_name?row.user.etm_name+'':'无'" placement="right">
												<div class="dian">{{row.user&&row.user.etm_name?row.user.etm_name+'':'无'}}</div>
											</el-tooltip>
										</div>
										<div class="titleFont">etm 姓名</div>
									</li>
									
									<li>
										<div class="content">
											<el-tooltip :content="row.user&&row.user.etm_nickname?row.user.etm_nickname+'':'无'" placement="right">
												<div class="dian">{{row.user&&row.user.etm_nickname?row.user.etm_nickname+'':'无'}}</div>
											</el-tooltip>
										</div>
										<div class="titleFont">etm 昵称</div>
									</li>
									
									<li>
										<div class="content">
											<el-tooltip :content="row.user&&row.user.birthday?row.user.birthday+'':'无'" placement="right">
												<div class="dian">{{row.user&&row.user.birthday?row.user.birthday+'':'无'}}</div>
											</el-tooltip>
										</div>
										<div class="titleFont">生日</div>
									</li>
									

									<li>
										<div class="content">
											<el-tooltip :content="row.remark?row.remark+'':'无'" placement="right">
												<div class="dian">{{row.remark?row.remark+'':'无'}}</div>
											</el-tooltip>
										</div>
										<div class="titleFont">订单备注</div>
									</li>



									<!-- 					<li>
										<el-tooltip :content="row.created_at+''" placement="right">

											<div class="content dis">
												{{row.created_at | timeBreak2}}
											</div>
										</el-tooltip>
										<div class="titleFont">创建时间</div>
									</li> -->







								</ul>



								<div style="width: 100px;display: flex;justify-content: start;align-items: center;margin-left: 10px;">
									<el-dropdown trigger="hover" style="width: 80px;">
										<el-button size="mini" round type="primary">
											操作<i class="el-icon-arrow-down el-icon--right"></i>
										</el-button>
										<el-dropdown-menu slot="dropdown">
											<div class="dis" style="flex-direction: column;">
												<!-- 0: 待付款, 1: 待发货, 2: 已发货, 3: 已完成, 4: 已取消, 5: 申请退款, 6: 退货中, 7: 退货完成 -->

												<!-- 查看详情按钮start -->
												<el-dropdown-item>
													<el-button type="success" size="mini" round @click="showOrderDetailModal(row)">查看详情
													</el-button>
												</el-dropdown-item>
												<!-- 查看详情按钮end -->
												
												<!-- 扣除课时start -->
												<el-dropdown-item v-if="(row.order_status == 1 || row.order_status == 2) && row.course_status == 0">
													<el-button type="success" size="mini" round @click="tuiHuiKeShi(row.id,1)">扣除课时
													</el-button>
												</el-dropdown-item>
												<!-- 扣除课时end -->
												
												
												<!-- 更新物流按钮start -->
												<el-dropdown-item v-if="row.order_status ==1&&row.express_type!=4&&row.express_type!=5">
													<el-button type="success" size="mini" round @click="showAddWuLiu(row)">更新物流
													</el-button>
												</el-dropdown-item>
												<!-- 更新物流按钮end -->
												<!-- 确认完成start -->
												<el-dropdown-item v-if="row.order_status == 1 && (row.express_type == 4 || row.express_type == 5)">
													<el-button type="danger" size="mini" round @click="showQueRenSelectPop(row)">确认完成
													</el-button>
												</el-dropdown-item>
												<!-- 确认完成end -->
												
												<!-- 已开发票start -->
												<el-dropdown-item v-if="row.invoice_status==1">
													<el-button type="warning" size="mini" round @click="invoice(row)">已开发票
													</el-button>
												</el-dropdown-item>
												<!-- 已开发票end -->
												<template v-if="row.refund_status == 1">
													
													<!-- 确认退款start -->
													<el-dropdown-item>
														<el-button type="danger" size="mini" round @click="showTuiKuanSelectPop(row,7)">确认退款
														</el-button>
													</el-dropdown-item>
													<!-- 确认退款end -->
													<!-- 寄回商品start refund-->
													<el-dropdown-item v-if="row.express_type!=4&&row.express_type!=5">
														<el-button type="danger" size="mini" round @click="showTuiKuanSelectPop(row,6)">寄回商品
														</el-button>
													</el-dropdown-item>
													<!-- 寄回商品end -->
													<!-- 拒绝退款start -->
													<el-dropdown-item>
														<el-button type="danger" size="mini" round @click="showTuiKuanSelectPop(row,8)">拒绝退款
														</el-button>
													</el-dropdown-item>
													<!-- 拒绝退款end -->
												</template>
												
												<!-- 门店角色的订单补款start -->
												<el-dropdown-item v-if="row.repayment_status ==0&&(role=='store_admin'||role=='store_sa')">
													<el-button type="success" size="mini" round @click="showPayImg([row.id])">订单补款
													</el-button>
												</el-dropdown-item>
												
												<!-- order_status 订单状态 (0: 待付款, 1: 已付款, 2: 已完成, 3: 已取消, 4: 已关闭) -->
												<!-- 当订单状态为 已付款 已完成 补款状态为待补款时, 后台管理员可手动确认补款完成(私下转账 -->
												<el-dropdown-item v-if="(row.order_status==1 || row.order_status==2)&&row.repayment_status ==0&&(role=='hq_admin')">
													<el-button type="success" size="mini" round @click="buKuanFinish(row.id)">补款完成
													</el-button>
												</el-dropdown-item>
												
												<!-- 当订单状态为 已付款 已完成 已关闭 补款状态为确认补款时(4), 后台管理员可手动改为已退回 -->
												<el-dropdown-item v-if="(row.order_status==1 || row.order_status==2 || row.order_status==4)&&row.repayment_status ==4&&(role=='hq_admin')">
													<el-button type="success" size="mini" round @click="buKuanTuiHui(row.id)">补款退回
													</el-button>
												</el-dropdown-item>
												
												<!-- 门店角色的订单补款end -->
												
												
												



											</div>


										</el-dropdown-menu>
									</el-dropdown>

								</div>


							</div>

						</template>
					</el-table-column>



















				</el-table>
			</div>

			<!--分页start-->
			<el-row type="flex" justify="end" align="middle" class="page" style="margin-top: 10px;margin-right: 50px;padding-bottom: 10px;">
				<el-pagination background layout="prev, pager, next" :current-page="pageNumber" :page-size="pageSize" :total="total" @current-change="changePage"></el-pagination>
				<span style="font-size: 13px;color: #999;">共 {{total}} 条</span>
			</el-row>
			<!--表格end-->


		</div>

		<!-- 商品详情弹窗start -->
		<el-dialog :close-on-click-modal="false" :visible.sync="isShowOrderDetailModal" title="" width="80%">
			<order-detail ref="orderDetail"></order-detail>

		</el-dialog>
		<!-- 商品详情弹窗end -->
		
		
		
		
		
		
		
		
		
		
		
		
		
		
		
		<!-- 确认完成弹窗start -->
		<el-dialog :close-on-click-modal="false" center :visible.sync="isShowQueRenPop" title="确认完成" width="600px">
		
			<div style="text-align: center;">
		
				<div style="text-align: left;margin-bottom: 50px;">
					
					<el-checkbox style="margin-left: 20px;" v-model="mQueRenCheckAll" @change="handleCheckAllChangeQueRen">全选</el-checkbox>
					<div style="margin: 15px 0;"></div>
					<el-checkbox-group v-model="mQueRenCheckList" @change="handleCheckedCitiesChangeQueRen">
						
						<div  style="display: flex;align-items: center;margin:20px;" v-for="(item,index) in currentQueRenObj.mQueRenGoodsArr" :key="item.id">
							
							
							
							<div style="color: #333333;">
							
								<div style="">
									
									<div class="titleFont" style="margin-left:-20px; display: flex;align-items: center;margin-bottom:10px; width:545px; font-size: 10px;color: #666;text-align: left;padding-left: 20px;background-color: #f8f8f8;padding-top: 3px;padding-bottom: 3px;border-radius: 20px;">
										<el-checkbox  :label="item.id" style="margin-bottom: 2px;"> <span style="opacity: 0;"> {{index}}</span></el-checkbox>
										
										<span v-if="item.status==0" style="margin-left: 5px;">状态: 待付款</span>
										<span v-else-if="item.status==1&&currentQueRenObj.express_type==4&&(currentQueRenObj.activity_type==1||currentQueRenObj.activity_type==0||currentQueRenObj.activity_type==3)" style="margin-left: 5px;">状态: 待自提</span>
										<span v-else-if="item.status==1&&currentQueRenObj.express_type==4&&currentQueRenObj.activity_type==4" style="margin-left: 5px;">状态: 待核销</span>
										<span v-else-if="item.status==1&&currentQueRenObj.express_type==4&&currentQueRenObj.activity_type==5" style="margin-left: 5px;">状态: 待体验</span>
										<span v-else-if="item.status==1&&currentQueRenObj.express_type==5" style="margin-left: 5px;">状态: 待闪送</span>
										
										
										<span v-else-if="item.status==1" style="margin-left: 5px;">状态: 待发货</span>
										<span v-else-if="item.status==2" style="margin-left: 5px;">状态: 待收货</span>
										<span v-else-if="item.status==3" style="margin-left: 5px;">状态: 已完成</span>
										<span v-else-if="item.status==4" style="margin-left: 5px;">状态: 已取消</span>
										<span v-else-if="item.status==5" style="margin-left: 5px;">状态: 申请退款</span>
										<span v-else-if="item.status==6" style="margin-left: 5px;">状态: 退货中</span>
										<span v-else-if="item.status==7" style="margin-left: 5px;">状态: 退货完成</span>
										
										
									</div>
								</div>
								<div style="display: flex;">
									
									<img :src="item.image" style="width: 60px;height: 60px;margin-right: 5px;border-radius: 5px;"/>
									<div style="text-align: left;">
										<div style="font-size: 12px;margin-right: 10px;line-height: 15px;margin-bottom: 6px;">
											<el-tooltip :content="item.name" placement="right">
												<div style="overflow: hidden;text-overflow: ellipsis;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;">{{item.name}}</div>
							
											</el-tooltip>
										</div>
										
										<div style="font-size: 10px;line-height: 14px;margin-right: 10px;color: #888;">{{item.specs_value_str}}</div>
									</div>
								</div>
							
							</div>
						</div>
						
						
						
					</el-checkbox-group>
				</div>
		
		
			</div>
			<div class="dis" style="justify-content: flex-end;">
		
				<el-button type="primary" size="mini" round @click="queRenComfigBtn">确定
				</el-button>
			</div>
		</el-dialog>
		<!-- 确认完成弹窗end -->
		
		<!-- 退款弹窗start -->
		<el-dialog :close-on-click-modal="false" center :visible.sync="isShowTuiKuanPop" title="详情" width="600px">
		
			<div style="text-align: center;">
		
				<div style="text-align: left;margin-bottom: 50px;">
					
					<el-checkbox style="margin-left: 20px;" :disabled="select_all" v-model="mTuiKuanCheckAll" @change="handleCheckAllChangeTuiKuan">全选</el-checkbox>
					<div style="margin: 15px 0;"></div>
					<el-checkbox-group :disabled="select_all" v-model="mTuiKuanCheckList" @change="handleCheckedCitiesChangeTuiKuan">
						
						<div  style="display: flex;align-items: center;margin:20px;" v-for="(item,index) in currentTuiKuanObj.mTuiKuanGoodsArr" :key="item.id">
							
							
							
							<div style="color: #333333;">
							
								<div style="">
									
									<div class="titleFont" style="margin-left:-20px; display: flex;align-items: center;margin-bottom:10px; width:545px; font-size: 10px;color: #666;text-align: left;padding-left: 20px;background-color: #f8f8f8;padding-top: 3px;padding-bottom: 3px;border-radius: 20px;">
										<el-checkbox  :label="item.id" style="margin-bottom: 2px;"> <span style="opacity: 0;"> {{index}}</span></el-checkbox>
										
										<span v-if="item.status==0" style="margin-left: 5px;">状态: 待付款</span>
										<span v-else-if="item.status==1&&currentTuiKuanObj.express_type==4&&(currentTuiKuanObj.activity_type==1||currentTuiKuanObj.activity_type==0||currentTuiKuanObj.activity_type==3)" style="margin-left: 5px;">状态: 待自提</span>
										<span v-else-if="item.status==1&&currentTuiKuanObj.express_type==4&&currentTuiKuanObj.activity_type==4" style="margin-left: 5px;">状态: 待核销</span>
										<span v-else-if="item.status==1&&currentTuiKuanObj.express_type==4&&currentTuiKuanObj.activity_type==5" style="margin-left: 5px;">状态: 待体验</span>
										<span v-else-if="item.status==1&&currentTuiKuanObj.express_type==5" style="margin-left: 5px;">状态: 待闪送</span>
										
										<span v-else-if="item.status==1" style="margin-left: 5px;">状态: 待发货</span>
										<span v-else-if="item.status==2" style="margin-left: 5px;">状态: 待收货</span>
										<span v-else-if="item.status==3" style="margin-left: 5px;">状态: 已完成</span>
										<span v-else-if="item.status==4" style="margin-left: 5px;">状态: 已取消</span>
										<span v-else-if="item.status==5" style="margin-left: 5px;">状态: 申请退款</span>
										<span v-else-if="item.status==6" style="margin-left: 5px;">状态: 退货中</span>
										<span v-else-if="item.status==7" style="margin-left: 5px;">状态: 退货完成</span>
										
										
									</div>
								</div>
								<div style="display: flex;">
									
									<img :src="item.image" style="width: 60px;height: 60px;margin-right: 5px;border-radius: 5px;"/>
									<div style="text-align: left;">
										<div style="font-size: 12px;margin-right: 10px;line-height: 15px;margin-bottom: 6px;">
											<el-tooltip :content="item.name" placement="right">
												<div style="overflow: hidden;text-overflow: ellipsis;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;">{{item.name}}</div>
							
											</el-tooltip>
										</div>
										
										<div style="font-size: 10px;line-height: 14px;margin-right: 10px;color: #888;">{{item.specs_value_str}}</div>
									</div>
								</div>
							
							</div>
						</div>
						
						
						
					</el-checkbox-group>
				</div>
		
		
			</div>
			<div class="dis" style="justify-content: flex-end;">
		
				<el-button type="primary" size="mini" round @click="tuiKuanComfigBtn">确定
				</el-button>
			</div>
		</el-dialog>
		<!-- 退款弹窗end -->
		
		
		
		
		
		
		
		
		
		
		
		
		
		
		
		
		
		
		
		
		
		
		
		
		
		

		<!-- 添加物流弹窗start -->
		<el-dialog :close-on-click-modal="false" center :visible.sync="isShowAddWuLiu" title="更新物流" width="600px">

			<div style="text-align: center;">

				<div style="text-align: left;margin-bottom: 50px;">
					
					<el-checkbox style="margin-left: 20px;" v-model="mCheckAll" @change="handleCheckAllChange">全选</el-checkbox>
					<div style="margin: 15px 0;"></div>
					<el-checkbox-group v-model="mCheckList" @change="handleCheckedCitiesChange">
						<div style="display: flex;align-items: center;margin:20px;" v-for="(item,index) in currentAddWuLiu.goods" :key="item.id">
							
							
							
							<div style="color: #333333;">
							
								<div style="">
									
									<div class="titleFont" style="margin-left:-20px; display: flex;align-items: center;margin-bottom:10px; width:545px; font-size: 10px;color: #666;text-align: left;padding-left: 20px;background-color: #f8f8f8;padding-top: 3px;padding-bottom: 3px;border-radius: 20px;">
										<el-checkbox  :label="item.id" style="margin-bottom: 2px;"> <span style="opacity: 0;"> {{index}}</span></el-checkbox>
										
										<span>快递名称:</span><span style="margin-left: 5px;">{{item.express_name?item.express_name:'无'}}</span>
										<span style="margin-left: 10px;">快递单号:</span><span style="margin-left: 5px;">{{item.express_num?item.express_num:'无'}}</span>
										
										<span style="margin-left: 10px;">发货时间:</span>
										<span v-if="item.express_time" style="margin-left: 5px;">{{ item.express_time | dateNumToString }}</span>
										<span v-else style="margin-left: 5px;">无</span>
									</div>
								</div>
								<div style="display: flex;">
									
									<img :src="item.image" style="width: 60px;height: 60px;margin-right: 5px;border-radius: 5px;"/>
									<div style="text-align: left;">
										<div style="font-size: 12px;margin-right: 10px;line-height: 15px;margin-bottom: 6px;">
											<el-tooltip :content="item.name" placement="right">
												<div style="overflow: hidden;text-overflow: ellipsis;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;">{{item.name}}</div>
							
											</el-tooltip>
										</div>
										
										<div style="font-size: 10px;line-height: 14px;margin-right: 10px;color: #888;">{{item.specs_value_str}}</div>
									</div>
								</div>
							
							</div>
						</div>
						
					</el-checkbox-group>
				</div>




				<div class="dis" style="margin: 20px 0;">
					<span>物流公司:</span>


					<el-select size="mini" v-model="addWuLiuByShippingName" placeholder="请选择物流名称" clearable style="width: 250px;margin-left: 10px;">

						<el-option v-for="(item,index) in expressList" :value="item.name" :label="item.name"></el-option>

					</el-select>

				</div>
				<div class="dis" style="margin: 20px 0;">
					<span>物流单号:</span>
					<el-input size="mini" v-model="addWuLiuByShippingNo" placeholder="请输入物流单号" style="width: 250px;margin-left: 10px;" />
				</div>


			</div>
			<div class="dis" style="justify-content: flex-end;">

				<el-button type="primary" size="mini" round @click="addWuLiuOKBtn">确定
				</el-button>
			</div>
		</el-dialog>
		<!-- 添加物流弹窗end -->


		<!-- 物流信息弹窗start -->
		<el-dialog :close-on-click-modal="false" center :visible.sync="isShowWuLiu" title="物流信息" width="700px">

			<div>

				<!-- 物流信息start -->
				<div style="padding: 20px;border-top: 1rpx solid #fff;padding-top: 0;">

					<div class="dis" style="font-weight: bold; font-size: 14px;padding: 10px 0;color: #393939;padding-bottom: 20px;">
						<div class="dis">
							<div>{{currentWuLiu.express_name}}</div>
							<div style="margin-left: 10px;">{{currentWuLiu.express_num}}</div>

						</div>

					</div>

					<!-- 物流时间轴 -->
					<div>

						<template v-if="currentWuLiu.detail&&currentWuLiu.detail.length>0">
							<div v-for="(item,index) in currentWuLiu.detail" :key="index">

								<div style="position: relative;display: flex;align-items: center;color:#9A9A9A;padding-left: 10px;">

									<div :style="{'background-color': index==0?'red':'#9A9A9A'}" style="width: 10px;height: 10px;border-radius: 50%;position: absolute;top:50%;left:5px;transform: translateY(-50%);"></div>

									<div style="padding:15px;padding-left: 20px; border-left: 1px solid rgba(207, 207, 207, 0.3);padding-right: 10px;">
										<div style="margin-bottom: 10px;">{{item.time}}</div>
										{{item.context}}
									</div>

								</div>

							</div>
						</template>
						<div v-else style="text-align: center;margin: 50px 0;color: #9A9A9A;">暂无物流信息~</div>

					</div>
				</div>

			</div>
			<!-- 物流信息end -->
		</el-dialog>
		<!--物流信息弹出end -->

		<el-dialog :close-on-click-modal="false" v-model="isShowOrderModal" title="订单商品" width="500" footer-hide>
			<div v-for="(item,index) in currentOrderListObj" :key="index" style="margin: 10px 20px 10px 20px; display: flex;justify-content: space-between;">
				<div style="width: 400px;color: #333333;">
					<div style="display: flex;">
						<img :src="item.listPicUrl" style="width: 60px;height: 60px;margin-right: 5px;border-radius: 5px;" @click="handlePreView(item.listPicUrl)" />
						<div style="text-align: left;">
							<div style="font-size: 13px;margin-right: 10px;">{{item.goodsName}}</div>
							<div style="font-size: 12px;margin-right: 10px;color: #888;">{{item.goodsSpecifitionName}}</div>

						</div>
					</div>

				</div>

				<div style="text-align: right;font-size: 13px;color: #888;">
					<div>
						<span style="font-size: 10px;margin-right: 3px;">¥</span>{{(item.retailPrice/100).toFixed(2)}}
					</div>
					<div>
						{{item.number}}件
					</div>
				</div>
			</div>

		</el-dialog>

		<el-dialog :close-on-click-modal="false" v-model="delModal.show" title="提示" @on-ok="deleteOK" @on-cancel="deleteCancel">
			<p>你确定要删除数据吗？</p>
		</el-dialog>

		<!-- :width="preView.width" -->
		<el-dialog :close-on-click-modal="false" title="预览" :visible.sync="preView.show" width="30%" footer-hide>
			<img :src="preView.imgUrl " v-if="preView.show" style="width: 100%">
		</el-dialog>


		<el-dialog :close-on-click-modal="false" title="" width="90%" :visible.sync="isShowFanXianModal">
			<div class="dis">
				<div style="display: flex;align-items: center;">
					<div>选择门店：</div>
					<el-select size="mini" v-model="storeByFanxianId" placeholder="请选择门店">
						<el-option v-for="item in fanxianStoreArr" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>

					<div style="margin-left: 30px;">返现状态：</div>

					<el-select size="mini" v-model="storeByFanxianState" placeholder="请选择状态" clearable>
						<el-option label="未发放" :value="0">
						</el-option>
						<el-option label="已发放" :value="1">
						</el-option>
					</el-select>
					<el-button type="primary" size="mini" round @click="selectFanXianList" style="margin-left: 20px;">查询</el-button>
					<el-button type="success" size="mini" round @click="yiJianFanXian" style="margin-left: 30px;">一键返现</el-button>
				</div>
			</div>
			<div style="margin-top: 20px;">
				<el-table :cell-style="{'text-align':'center'}" :header-cell-style="{'text-align':'center'}" :data="fanxianArr" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChangeFX">
					<!-- <el-table-column
				      type="selection"
				      width="55">
				    </el-table-column> -->

					<el-table-column prop="id" label="id" width="120">
					</el-table-column>
					<el-table-column prop="order_code" label="订单编号" width="120">
					</el-table-column>
					<el-table-column prop="order_price" label="订单金额" width="100">
					</el-table-column>
					<el-table-column prop="goods_price" label="商品金额" width="100">
					</el-table-column>
					<el-table-column prop="supply_price" label="供货金额" width="100">
					</el-table-column>
					<el-table-column prop="course_price" label="课时金额" width="100">
					</el-table-column>
					<el-table-column prop="discount_price" label="优惠金额" width="100">
					</el-table-column>
					<el-table-column prop="payment_price" label="付款金额" width="100">
					</el-table-column>
					<el-table-column prop="refund_price" label="退款金额" width="100">
					</el-table-column>
					<el-table-column prop="repayment_price" label="补款金额" width="100">
					</el-table-column>
					<el-table-column prop="repayment_status" label="补款状态" width="120">
						<template slot-scope="scope">
							<div v-if="scope.row.repayment_status==0" style="color: red;">未补款</div>
							<div v-if="scope.row.repayment_status==1" style="color: green;">已补款</div>
							<div v-if="scope.row.repayment_status==2" style="color: green;">已退回</div>
							<div v-if="scope.row.repayment_status==3" style="color: green;">无需操作</div>
							<div v-if="scope.row.repayment_status==4" style="color: green;">已确认</div>
						</template>
					</el-table-column>
					<el-table-column prop="bounty_price" label="返现金额" width="120">
					</el-table-column>
					<el-table-column prop="bounty_status" label="返现状态" width="120">
						<template slot-scope="scope">
							<div v-if="scope.row.bounty_status==0" style="color: red;">未发放</div>
							<div v-if="scope.row.bounty_status==1" style="color: green;">已发放</div>
							<div v-if="scope.row.bounty_status==3" style="color: green;">无需操作</div>
						</template>
					</el-table-column>
					<el-table-column prop="created_at" label="创建时间" width="110">
					</el-table-column>
					<el-table-column label="门店名称" width="100">
						<template slot-scope="scope">
							<el-tooltip :content="scope.row.store.name">
								<div style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">{{scope.row.store.name}}</div>
								
							</el-tooltip>
							
						</template>
					</el-table-column>
					
					
				
					
					

					

					<!-- <el-table-column label="操作">
						<template slot-scope="scope">
							<el-button type="warning" round v-if="scope.row.bounty_status==1" size="mini" @click="fafangFanXianItem(scope.row,0)">取消发放</el-button>
							<el-button round v-if="scope.row.bounty_status==0" size="mini" type="success" @click="fafangFanXianItem(scope.row,1)">确定发放</el-button>
						</template>
					</el-table-column> -->


				</el-table>
			</div>
			<div style="display: flex;justify-content: flex-end;margin-top: 50px;">
				<!--分页start-->
				<el-row type="flex" justify="end" align="middle" class="page" style="margin-top: 10px;margin-right: 50px;padding-bottom: 10px;">
					<el-pagination background layout="prev, pager, next" :current-page="pageNumberFX" :page-size="pageSizeFX" :total="totalFX" @current-change="changePageFX"></el-pagination>
					<span style="font-size: 13px;color: #999;">共 {{totalFX}} 条</span>
				</el-row>

			</div>
		</el-dialog>
		
		<!-- 补款弹窗start -->
		<el-dialog :close-on-click-modal="false" @close="clearTimer" :visible.sync="isShowBuKuanModal" title="" width="400px">
			<div class="dis" style="flex-direction: column;">
				<div style="margin-bottom: 30px;font-size: 18px;font-weight: bold;">请使用微信支付：￥{{total_price}}</div>
		
				<div id="qrCode" ref="qrCodeDiv"></div>
		
			</div>
		
		</el-dialog>
		<!-- 补款弹窗end -->

	</div>
</template>

<script>
	import QRCode from 'qrcodejs2';
	import {
		ajax
	} from '../../util/ajax.js';
	import excel from '@/components/excel/excel.js'
	import exportObj from '@/components/excel/excelByHtml.js'
	import orderDetail from './orderDetail.vue'
	import _ from 'lodash'
	import config from '@/util/config.js'

	export default {
		name: 'orderList',
		components: {

			orderDetail
		},
		data() {
			return {
				role:'',
				
				isShowBuKuanModal: false,
				total_price: '',
				
				price: '',
				mobileWidth: window.mobileWidth + 100,
				isMobile: window.isMobile,

				isShowCollapse: false, //是否展开搜索项
				daoruExcel: [], //导入excel
				storeList: [], //门店列表

				currentAddWuLiu: '', //当前行
				mCheckList:[],
				mCheckAll:[],
				isShowAddWuLiu: false, //是否显示添加物流弹窗
				addWuLiuByShippingNo: '', //添加的物流单号
				addWuLiuByShippingName: '', //添加的物流公司名称
				
				
				
				currentQueRenObj: '', //当前行数据
				mQueRenCheckList:[],//选中的项
				mQueRenCheckAll:[],//全选
				isShowQueRenPop: false, //是否显示确认完成弹窗
				
				
				
				tuiKuanState:'',
				currentTuiKuanObj: '', //当前行数据
				mTuiKuanCheckList:[],//选中的项
				mTuiKuanCheckAll:[],//全选
				isShowTuiKuanPop: false, //是否显示确认完成弹窗
				

				currentWuLiu: '', //当前显示的物流数据
				isShowWuLiu: false, //是否显示物流信息

				isShowOrderDetailModal: false, //是否显示订单详情窗口
				isShowFanXianModal: false, //是否显示返现列表弹窗
				storeByFanxianState: '', //返现列表的状态
				storeByFanxianIdOld: '',

				fanxianStoreArr: [], //返现的门店列表
				fanxianArr: [], //返现的列表
				fanxianTotal: '',
				storeByFanxianId: '', //选中的要返现的门店对象
				multipleSelectionFX: [], //返现选中的所有项

				currentOrderListObj: '', //当前显示的订单商品对象列表
				isShowOrderModal: false, //是否显示订单商品列表
				tableHeight: 0, //表格高度
				modal: {
					show: false,
					title: '详情'
				},
				preView: {
					show: false,
					imgUrl: '',
					width: 600
				},
				selectData: [], //选中项的数据
				delModal: {
					show: false,
					guid: ''
				},
				row2modal: {},
				loading: true,
				searchForm: {
					order_status: "",
					invoice_status: '',
					express_type:[]
				},
				pageNumber: 1, // 当前页数
				pageSize: 10, // 页面大小
				total: 0,

				pageNumberFX: 1, // 当前页数
				pageSizeFX: 5, // 页面大小
				totalFX: 0,

				expressList: [],
				tableColumnsChecked: ['guid', 'orderSn', 'g_goodsName', 't_wechatNick', 'type', 'status', 'payTime', 'mobile', 'updateTime'],
				columns: [],
				tableData: [],
				datetimePickeOption: config.datetimePickeOption,
        select_all:false,//全部旋转
			}
		},

		filters: {
			//把 2021-07-30 11:07:36 格式为 07-30
			//								11:07
			//使用格式 <p>{{row.stateChangeTime | timeBreak(0)}}</p>    <p>{{row.stateChangeTime | timeBreak(1)}}</p> 
			timeBreak(time, type, from) {
				if (time) {
					return type == 0 ? (from == undefined ? time.substr(5, 5) : time.substr(0, 10)) : (type == 2 ? time
					.substr(0, 10) : (from == undefined ? time.substr(11, 5) : time.substr(11, 8)));
				} else {
					return time;
				}
			},
			
			dateNumToString(num) {
				
				
				let d = new Date(num*1000);
				
				var _y = d.getFullYear();
				var _m = d.getMonth() < 10 ? "0" + d.getMonth() : d.getMonth();
				var _d = d.getDate() < 10 ? "0" + d.getDate() : d.getDate(); 
				var _w = d.getDay();
				var _h = d.getHours() < 10 ? "0" + d.getHours() : d.getHours(); 
				var _mm = d.getMinutes() < 10 ? "0" + d.getMinutes() : d.getMinutes();
				var _s =  d.getSeconds() < 10 ? "0" + d.getSeconds() : d.getSeconds();
				//字符串的拼接
				var str = _y + "-" + (parseInt(_m) + 1) + "-" + _d + " " + _h + ":" + _mm;
				return str;
			
			},

			timeBreak2(val) {

				let v = val.split(' ')[0];

				return v;
			},

		},

		created() {
			this.getTableHeight();
		},
		mounted() {
			this.role = localStorage.getItem("role")?localStorage.getItem("role").replace(/3alxi2fdksjfkljwijljsk128ldfln324kodnvjdsl32432jfiwefjls32432idaxpoife983iw2/g,''):'';//获取当前用户角色
					
			//挂载window.onresize事件(动态设置table高度)
			let _this = this;
			window.onresize = () => {
				if (_this.resizeFlag) {
					clearTimeout(_this.resizeFlag);
				}
				_this.resizeFlag = setTimeout(() => {
					_this.getTableHeight();
					_this.resizeFlag = null;
				}, 100);
			};



			if (this.$route.query.orderStatus) { //待发货状态的
				this.searchForm.order_status = Number(this.$route.query.orderStatus);
			}

			if (this.$route.query.invoice_status) { //待发货状态的
				this.searchForm.invoice_status = Number(this.$route.query.invoice_status);
			}






			if(this.role=='hq_admin'){
				this.getStore();
			}
			
			this.initData();
			this.getExpress();
		},

		methods: {




			statusChange(v) {
				console.log('====>', v)
				this.searchForm.order_status = v;
			},

			invoiceChange(v) {
				console.log('====>', v)
				this.searchForm.invoice_status = v;
			},

			express_typeChange(v) {
				console.log('====>', v)
				this.searchForm.express_type = v;
			},

			//补款完成
			async buKuanFinish(order_id) {
				
				this.$confirm( '确认补款完成吗？','提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(async () => {
					
					this.loading = true;
					let res = await ajax('/hq/order/repayment/complete', 'POST', {
						order_id
					});
					this.loading = false;
					this.$message({
						type: 'success',
						message: '成功!'
					});
					this.initData();
				
				
				}).catch(() => {
				
				});
			
			},
			
			
			//补款退回
			async buKuanTuiHui(order_id) {
				this.$confirm( '确认补款退回吗？','提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(async () => {
					
					this.loading = true;
					let res = await ajax('/hq/order/repayment/refund', 'POST', {
						order_id
					});
					this.loading = false;
					this.$message({
						type: 'success',
						message: '成功!'
					});
					this.initData();
				
				}).catch(() => {
				
				});
			
			},
			

			//获取物流列表
			async getExpress() {
				let ress = await ajax('/express/list', 'GET');
				let res = ress.data.data;
				this.expressList = res.express;

			},
			//获取门店列表
			async getStore() {
				let ress = await ajax('/hq/store', 'GET');
				let res = ress.data.data;
				this.storeList = res.store;
			},

			async initData() {
				this.loading = true
				var searchForm = this.searchForm;

				if (searchForm.mobile === "") { //select未选中为空字符串
					searchForm.mobile = undefined; //为null后就不会作为http请求参数了带给后端了
				}

				if (searchForm.store_id === "") { //select未选中为空字符串
					searchForm.store_id = undefined; //为null后就不会作为http请求参数了带给后端了
				}

				if (searchForm.order_code === "") { //select未选中为空字符串
					searchForm.order_code = undefined; //为null后就不会作为http请求参数了带给后端了
				}


				if (searchForm.course_status === "") { //select未选中为空字符串
					searchForm.course_status = undefined; //为null后就不会作为http请求参数了带给后端了
				}

				if (searchForm.repayment_status === "") { //select未选中为空字符串
					searchForm.repayment_status = undefined; //为null后就不会作为http请求参数了带给后端了
				}

				if (searchForm.bounty_status === "") { //select未选中为空字符串
					searchForm.bounty_status = undefined; //为null后就不会作为http请求参数了带给后端了
				}

				if (searchForm.express_type === "") { //select未选中为空字符串
					searchForm.express_type = undefined; //为null后就不会作为http请求参数了带给后端了
				}
				
				if (searchForm.express_type&&searchForm.express_type.length == 0) { //select未选中为空字符串
					searchForm.express_type = undefined; //为null后就不会作为http请求参数了带给后端了
				}
				
				if (searchForm.activity_type === "") { //select未选中为空字符串
					searchForm.activity_type = undefined; //为null后就不会作为http请求参数了带给后端了
				}

				if (searchForm.role === "") { //select未选中为空字符串
					searchForm.role = undefined; //为null后就不会作为http请求参数了带给后端了
				}

				if (searchForm.invoice_status === ""||searchForm.invoice_status === null) { //select未选中为空字符串
					searchForm.invoice_status = undefined; //为null后就不会作为http请求参数了带给后端了
				}

				if (searchForm.date === "" || searchForm.date ===null) { //select未选中为空字符串
					searchForm.date = undefined; //为null后就不会作为http请求参数了带给后端了
				}

				if (searchForm.date && searchForm.date.length > 0) {
					//日期重新赋值为时间戳日期
					let arr = searchForm.date;
					if (arr[0].getTime) {
						searchForm.date = [arr[0].getTime(), arr[1].getTime()];
					} else {
						searchForm.date = arr;
					}
				}

				if (searchForm.order_status === ""||searchForm.order_status === null) { //select未选中为空字符串
					searchForm.order_status = undefined; //为null后就不会作为http请求参数了带给后端了
				}









				var pageSize = this.pageSize
				var pageNumber = this.pageNumber

				let param = {
					...searchForm,
					count: pageSize,
					page: pageNumber
				};
				//获取订单列表的接口start
				let res = await ajax('/order/list', 'POST', param);
				const data = res.data.data;
				this.tableData = data.order
				this.price = data.price;
				console.log('data.order=>', data.order)
				this.total = data.total
				this.loading = false;
				//获取订单列表的接口end



			},

			//补款显示二维码支付
			async showPayImg(arr) {
				this.loading = true;
				let res = await ajax('/store/order/repayment', 'POST', {
					order_id: arr
				});
				const data = res.data.data;
				this.total_price = data.total_price; //支付总金额
				this.repayment_order_id = data.repayment_order_id; //
				
				this.isShowBuKuanModal = true;
				
				
				
				setTimeout(() => {
					
					console.log("清除内容",this.$refs.qrCodeDiv)
					
					this.$refs.qrCodeDiv.innerHTML="";//清空已生成的二维码，否则会造成累加二维码的问题
					
					new QRCode(this.$refs.qrCodeDiv, {
						text: data.url,
						width: 300,
						height: 300,
						colorDark: "#333333", //二维码颜色
						colorLight: "#ffffff", //二维码背景色
						correctLevel: QRCode.CorrectLevel.L //容错率，L/M/H
					})
				}, 0)
			
				clearInterval(window.storeOrderTimer);
				window.storeOrderTimer = setInterval(async () => {
					console.log('询问')
					try {
						let res = await ajax('/store/order/repayment/verify', 'POST', {
							repayment_order_id: this.repayment_order_id
						});
						const data = res.data.data;
						if (data.status == 1) {
							this.$message({
								showClose: true,
								message: '补款成功',
								type: 'success'
							});
							this.initData();
							this.isShowBuKuanModal = false;
							clearInterval(window.storeOrderTimer);
						}
					} catch (e) {
						clearInterval(window.storeOrderTimer);
					}
			
				}, 1000)
				
				this.loading = false;
			},
			
			clearTimer() {
				console.log('关闭')
				clearInterval(window.storeOrderTimer);
			},
			
			//退款审核通过
			async refund(row, status) {
				let text = '';
				if (status == 6) {
					text = '确定退款审核通过吗？';
				}
				if (status == 8) {
					text = '确定退款审核失败吗？';
				}
				if (status == 7) {
					text = '确定退款吗？';
				}
				if (status == '8+') {
					text = '确定拒绝退款吗？';
					status = 8;
				}

				this.$confirm(text, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(async () => {

					this.loading = true;
					let res = await ajax('/order/refund', 'PUT', {
						order_id: row.id,
						status
					});
					this.loading = false;
					this.initData();
					this.$message({
						type: 'success',
						message: '成功!'
					});
					
					
				}).catch(() => {

				});
			},
			//添加物流
			addWuLiu(order_id) {

			},

		
		
		
		


			//闪送+自提的确认退款按钮
			async shanSongAndZiTiTuiKuanCom(row) {

				let text = '确定退款吗？';
				this.$confirm(text, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(async () => {

					this.loading = true;
					let res = await ajax('/store/order/refund', 'POST', {
						order_id: row.id
					});
					this.loading = false;
					this.initData();
					this.$message({
						type: 'success',
						message: '成功!'
					});
				}).catch(() => {

				});
			},

			//扣除或退回课时
			async tuiHuiKeShi(order_id, course_status) {

				let text = course_status == 1 ? '确定扣除课时吗？' : '确定退回课时吗？'
				this.$confirm(text, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(async () => {

					this.loading = true;
					let res = await ajax('/order/course', 'PUT', {
						order_id,
						course_status
					});
					this.loading = false;
					this.initData();
					this.$message({
						type: 'success',
						message: '成功!'
					});
				}).catch(() => {

				});

			},
			//已开发票按钮
			async invoice(row) {
				this.loading = true;
				let res = await ajax('/order/invoice', 'PUT', {
					order_id: row.id
				});
				this.loading = false;
				this.$message({
					type: 'success',
					message: '成功!'
				});
				this.initData();

			},
			//一键返现
			async yiJianFanXian() {
				if (!this.storeByFanxianId) {
					this.$message.error('请选择门店');

					return;
				}

				this.loading = true;
				let res = await ajax('/hq/order/bounty/all/price', 'GET', {
					store_id: this.storeByFanxianIdOld, //门店id
				});
				this.loading = false;
				let total = res.data.data.total; //返现总金额
				let key = res.data.data.key; //标识

				if (total == '0.00') {
					this.$message.error('暂无可返现');
					return;
				}

				let storeName = "";
				
				for (let item of this.fanxianStoreArr) {
					if(item.id == this.storeByFanxianIdOld){
						storeName = item.name;
					}
				}
				


				let text = storeName+'一共返现 ' + total + ' 元';
				this.$confirm(text, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(async () => {

					this.loading = true;
					let res = await ajax('/hq/order/bounty/all/complete', 'PUT', {

						store_id: this.storeByFanxianIdOld, //门店id
						key
					});
					this.loading = false;
					this.fanxianList();
					this.initData();
					this.$message({
						type: 'success',
						message: '成功!'
					});
				}).catch(() => {
					// this.$message({
					// 	type: 'info',
					// 	message: '已取消删除'
					// });
				});
			},
			//发放返现项
			async fafangFanXianItem(row, bounty_status) {
				let text = bounty_status == 0 ? '确定取消发放吗？' : '确定发放吗？'
				this.$confirm(text, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(async () => {

					this.loading = true;
					let res = await ajax('/hq/order/bounty/edit', 'PUT', {
						bounty_status,
						store_id: this.storeByFanxianIdOld, //门店id
						order_id: row.id
					});
					this.loading = false;
					this.fanxianList();
					this.initData();
					this.$message({
						type: 'success',
						message: '成功!'
					});
				}).catch(() => {
					// this.$message({
					// 	type: 'info',
					// 	message: '已取消删除'
					// });
				});
			},
			selectFanXianList() {
				this.fanxianArr = []; //这种可以让滚动条回到顶部
				this.pageNumberFX = 1
				this.fanxianList()
			},
			//返现门店列表
			async fanxianList() {
				if (!this.storeByFanxianId) {
					this.$message.error('请选择门店');

					return;
				}
				let p = {
					store_id: this.storeByFanxianId,
					count: this.pageSizeFX,
					page: this.pageNumberFX
				};

				this.storeByFanxianIdOld = this.storeByFanxianId;
				if (this.storeByFanxianState === 0 || this.storeByFanxianState == 1) {
					p.bounty_status = this.storeByFanxianState;
				}

				//获取返现的列表
				this.loading = true;
				let res = await ajax('/hq/order/bounty/list', 'GET', p);
				const data = res.data.data;
				this.totalFX = data.total
				this.fanxianArr = data.order;
				this.loading = false;
			},
			handleSelectionChangeFX(val) {
				this.multipleSelectionFX = val;
			},


			//计算table高度(动态设置table高度)
			getTableHeight() {
				let tableH = 200; //距离页面下方的高度
				let tableHeightDetil = window.innerHeight - tableH;

				if (tableHeightDetil <= 300) {
					this.tableHeight = 300;
				} else {
					this.tableHeight = window.innerHeight - tableH;
				}
			},

			//显示返现列表弹窗
			async showFanXianModal(row) {
				this.fanxianArr = [];
				this.pageNumberFX = 1;
				this.storeByFanxianId = "";
				this.storeByFanxianIdOld = '';
				this.storeByFanxianState = "";
				this.totalFX = 0;
				//获取门店列表
				let res = await ajax('/hq/store', 'GET');
				const data = res.data.data;


				this.isShowFanXianModal = true;
				this.fanxianStoreArr = data.store;
				this.fanxianTotal = data.total;
			},
			//展开搜索项
			isShowCollapseF() {
				this.isShowCollapse = !this.isShowCollapse;
			},
			//导入
			handleBeforeUpload(file) {


				this.loading = true
				const fileExt = file.name.split('.').pop().toLocaleLowerCase()
				if (fileExt === 'xlsx' || fileExt === 'xls') {
					this.readFile(file)
				} else {
					this.$Notice.warning({
						title: '文件类型错误',
						desc: '文件：' + file.name + '不是EXCEL文件，请选择后缀为.xlsx或者.xls的EXCEL文件。'
					})
					this.loading = false
				}
				return false
			},


			// 读取导入的excel文件
			readFile(file) {



				const reader = new FileReader()
				reader.readAsArrayBuffer(file)
				reader.onloadstart = e => {
					this.$Message.info('开始读取文件...')
				}
				reader.onprogress = e => {
					this.$Message.info('文件读取中...')
				}
				reader.onerror = e => {
					this.$Message.error('文件读取出错')
					this.loading = false
				}
				reader.onload = e => {

					const data = e.target.result
					const {
						header,
						results
					} = excel.read(data, 'array')
					const tableTitle = header.map(item => {
						return {
							title: item,
							key: item
						}
					})
					//console.log(data)
					//console.log(header)
					console.log('导入的结果==', results)
					//console.log(tableTitle)

					this.daoruExcel = results
					let httpParam = {
						list: []
					};
					results.forEach((item) => {
						let obj = {

						};
						if (item['订单标识'] == undefined) {
							this.$Message.error("请编写订单标识")
							return;
						}
						if (item['物流公司'] == undefined) {
							this.$Message.error("请编物流公司")
							return;
						}
						if (item['物流单号'] == undefined) {
							this.$Message.error("请编写物流单号")
							return;
						}


						obj.guid = item['订单标识'];
						obj.shippingName = item['物流公司'];
						obj.shippingNo = item['物流单号'];




						httpParam.list.push(obj)
					})
					if (httpParam.list.length == 0) {
						this.$Spin.hide();
						this.loading = false
						return;
					}

					api.importLogistics(
						httpParam
					).then(res => {
						let that = this;
						if (res.data.state && res.data.state === 'ok') {
							if (res.data.error.length > 0) {

								let content = '';
								res.data.error.forEach((item) => {
									content += item + '<br/>';
								})
								this.$Modal.error({
									title: "以下数据导入失败:",
									content: content,
									onOk() {
										that.initData();
									},
								});
								return;
							}
							this.$Message.info('导入成功')
							this.initData()
						} else {

							this.$Message.error(res.data.msg)
						}
						this.$Spin.hide();
					}).catch(err => {
						this.$Spin.hide();
						this.$Message.error(err)
					})



					this.loading = false
				}
			},


			//导出
			async exportXFnByHTML() {

				var searchForm = this.searchForm;
				
				if (searchForm.mobile === "") { //select未选中为空字符串
					searchForm.mobile = null; //为null后就不会作为http请求参数了带给后端了
				}
				
				if (searchForm.store_id === "") { //select未选中为空字符串
					searchForm.store_id = null; //为null后就不会作为http请求参数了带给后端了
				}
				
				if (searchForm.order_code === "") { //select未选中为空字符串
					searchForm.order_code = null; //为null后就不会作为http请求参数了带给后端了
				}
				
				
				if (searchForm.course_status === "") { //select未选中为空字符串
					searchForm.course_status = null; //为null后就不会作为http请求参数了带给后端了
				}
				
				if (searchForm.repayment_status === "") { //select未选中为空字符串
					searchForm.repayment_status = null; //为null后就不会作为http请求参数了带给后端了
				}
				
				if (searchForm.bounty_status === "") { //select未选中为空字符串
					searchForm.bounty_status = null; //为null后就不会作为http请求参数了带给后端了
				}
				
				if (searchForm.express_type === "") { //select未选中为空字符串
					searchForm.express_type = null; //为null后就不会作为http请求参数了带给后端了
				}
				if (searchForm.activity_type === "") { //select未选中为空字符串
					searchForm.activity_type = null; //为null后就不会作为http请求参数了带给后端了
				}
				
				if (searchForm.role === "") { //select未选中为空字符串
					searchForm.role = null; //为null后就不会作为http请求参数了带给后端了
				}
				
				if (searchForm.invoice_status === ""||searchForm.invoice_status === null) { //select未选中为空字符串
					searchForm.invoice_status = undefined; //为null后就不会作为http请求参数了带给后端了
				}
				
				if (searchForm.date === "" || searchForm.date === null) { //select未选中为空字符串
					searchForm.date = undefined; //为null后就不会作为http请求参数了带给后端了
				}
				
				if (searchForm.date && searchForm.date.length > 0) {
					//日期重新赋值为时间戳日期
					let arr = searchForm.date;
					if (arr[0].getTime) {
						searchForm.date = [arr[0].getTime(), arr[1].getTime()];
					} else {
						searchForm.date = arr;
					}
				}
				
				if (searchForm.order_status === ""||searchForm.order_status === null) { //select未选中为空字符串
					searchForm.order_status = undefined; //为null后就不会作为http请求参数了带给后端了
				}
				
				
				
				
				
				
				this.loading = true;
				let param = {
					...searchForm
				};

				let res = await ajax('/order/export', 'POST', param);
				const order = res.data.data.order;

				if (order.length == 0) {
					this.loading = false;
					this.$message.error('暂无导出信息~')
					return;
				}





				// tHeader和tbody的数据需要一一对应
				let tHeader = Object.keys(order[0]); //列头
				let tbody = order; //每列的列值
				//后面两个参数是图片宽度和高度,不建议导出图片，请求太慢
				exportObj.export2Excel(tHeader, tbody, '订单数据.xls')
				this.loading = false;





			},

			//导出
			exportXFn() {
				// if(this.selectData.length==0){
				// 	this.$Message.error('请勾选要导出的项')
				// 	return;
				// }

				//this.$Spin.show();导出中



				const params = {
					title: ["列名1", "列名2"], //代表列名一行
					key: ['a', 'b'], //代表列名对应的值的属性名并且值为下面对应的属性值
					data: [{
						a: '列值1',
						b: 222222222222222222222222222222
					}], //代表每一列的列数据
					autoWidth: true, //列自适应宽度
					filename: '文件名称'
				}
				excel.export_array_to_excel(params)





			},












			//打开商品详情弹窗
			showOrderDetailModal(row) {
				console.log('row',row)
				this.isShowOrderDetailModal = true; //是否显示订单详情窗口
				setTimeout(() => {
					this.$refs.orderDetail.initData(row);
				}, 500)

			},
			//显示添加物流
			showAddWuLiu(row) {

				this.addWuLiuByShippingNo = ''; //添加的物流单号
				this.addWuLiuByShippingName = ''; //添加的物流公司名称

				if (row.express_num) {
					this.addWuLiuByShippingNo = row.express_num; //添加的物流单号
					this.addWuLiuByShippingName = row.express_name; //添加的物流公司名称
				}


				this.currentAddWuLiu = row; //当前行对象
				this.mCheckAll = false; //是否全选
				this.mCheckList = []; //选中的项
				this.isShowAddWuLiu = true; //是否显示添加物流信息

			},
			
			
			
			
			
			
			
			
			
			
			
			
			
			
			
			
			
			
			
			
			
			
			//点击全选
			handleCheckAllChangeTuiKuan(val) {
				console.log('val',val)
				console.log('val',val,this.currentTuiKuanObj.mTuiKuanGoodsArr)
				if(val){
					let arr = [];
					for (let i of this.currentTuiKuanObj.mTuiKuanGoodsArr) {
						arr.push(i.id);
					}
					
					this.mTuiKuanCheckList =arr;
				}else{
					this.mTuiKuanCheckList =[];
				}
				
				console.log('this.mTuiKuanCheckList',this.mTuiKuanCheckList)
			},
			//点击项
			handleCheckedCitiesChangeTuiKuan(value){
				console.log('value',value)
				let checkedCount = value.length;//选中的项的总数
				this.mTuiKuanCheckAll = checkedCount === this.currentTuiKuanObj.mTuiKuanGoodsArr.length;//判断选中的项的个数是不是和所有项的个数
				
			},
			//显示选择商品弹窗
			showTuiKuanSelectPop(row,tuiKuanState){
        this.select_all = false
        if(tuiKuanState==7){
          if(row.course_count>0){
            this.select_all = true
          }
        }
        // console.log(this.select_all,'rrrrrrr')
        // return
				let arr = [];
				for (let item of row.goods) {
					if(item.status == 5 || item.status == 6){
						arr.push(item);
					}
					
				}
				this.tuiKuanState = tuiKuanState;
				row.mTuiKuanGoodsArr = arr;
				this.currentTuiKuanObj = row; //当前行对象
        console.log(this.currentTuiKuanObj,'this.currentTuiKuanObj')
				this.mTuiKuanCheckAll = false; //是否全选
				this.mTuiKuanCheckList = []; //选中的项
				this.isShowTuiKuanPop = true; //是否显示选择商品弹窗
				if(this.select_all==true){
          for(let index in row.goods){
            // console.log(row.goods[index],'6666')
            this.mTuiKuanCheckList.push(row.goods[index].id)
            this.mTuiKuanCheckAll = true; //是否全选
          }
        }
			},
			//点击选择弹窗上的确认按钮
			async tuiKuanComfigBtn() {
				if(this.currentTuiKuanObj.mTuiKuanGoodsArr.length==0){
					this.$message.error('暂无商品可操作')
					return;
				}
				if(this.mTuiKuanCheckList.length==0){
					this.$message.error('请选择商品')
					return;
				}
				
				
				
				let text = '';
				let status = this.tuiKuanState;
				if (status == 6) {
					text = '确定寄回商品吗？';
				}

				if (status == 7) {
					text = '确定退款吗？';
				}
				if (status == 8) {
					text = '确定拒绝退款吗？';
					status = 8;
				}
				
				this.$confirm(text, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(async () => {
				
					this.loading = true;
					let res = await ajax('/order/refund', 'PUT', {
					
						order_id: this.currentTuiKuanObj.id,
						order_goods_ids:this.mTuiKuanCheckList,//订单商品 ID数组
						status
					});
					this.loading = false;
					this.initData();
					this.isTuiKuanRenPop = false; //是否显示选择商品弹窗
					this.$message({
						type: 'success',
						message: '成功!'
					});
					this.isShowTuiKuanPop = false; //是否显示选择商品弹窗
					
				}).catch(() => {
				
				});
				
				
				
				
				
			},
			
			
			
			
			
			
			
			
			
			
			
			
			
			
			
			
			
			
			
			
			
			
			
			
			
			
			
			
			//点击全选
			handleCheckAllChangeQueRen(val) {
				console.log('val',val)
				if(val){
					let arr = [];
					for (let i of this.currentQueRenObj.mQueRenGoodsArr) {
						arr.push(i.id);
					}
					
					this.mQueRenCheckList =arr;
				}else{
					this.mQueRenCheckList =[];
				}
				
				console.log('this.mQueRenCheckList',this.mQueRenCheckList)
			},
			//点击项
			handleCheckedCitiesChangeQueRen(value){
				console.log('value',value)
				let checkedCount = value.length;//选中的项的总数
				this.mQueRenCheckAll = checkedCount === this.currentQueRenObj.mQueRenGoodsArr.length;//判断选中的项的个数是不是和所有项的个数
				
			},
			//显示选择商品弹窗
			showQueRenSelectPop(row){
				let arr = [];
				for (let item of row.goods) {
					if(item.status == 1 || item.status == 2){
						arr.push(item);
					}
				}
				row.mQueRenGoodsArr = arr;
				this.currentQueRenObj = row; //当前行对象
				this.mQueRenCheckAll = false; //是否全选
				this.mQueRenCheckList = []; //选中的项
				this.isShowQueRenPop = true; //是否显示选择商品弹窗
				
			},
			//点击选择弹窗上的确认按钮
			async queRenComfigBtn() {
				if(this.currentQueRenObj.mQueRenGoodsArr.length==0){
					this.$message.error('暂无商品可操作')
					return;
				}
				if(this.mQueRenCheckList.length==0){
					this.$message.error('请选择商品')
					return;
				}
				
				
				
				let text = '确定完成吗？';
				this.$confirm(text, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(async () => {
			
					this.loading = true;
					let res = await ajax('/order/complete', 'POST', {
						order_id: this.currentQueRenObj.id,
						order_goods_id:this.mQueRenCheckList//订单商品 ID数组
					});
					this.loading = false;
					this.initData();
					this.isShowQueRenPop = false; //是否显示选择商品弹窗
					this.$message({
						type: 'success',
						message: '成功!'
					});
				}).catch(() => {
			
				});
			},
			
			
			
			
			
			
			
			
			
			
			
			
			
			
			
			
			
			
			
			
			
			
			
			
			
			
			handleCheckAllChange(val) {
				console.log('val',val)
				if(val){
					let arr = [];
					for (let i of this.currentAddWuLiu.goods) {
						arr.push(i.id);
					}
					
					this.mCheckList =arr;
				}else{
					this.mCheckList =[];
				}
				
				console.log('this.mCheckList',this.mCheckList)
			},
			handleCheckedCitiesChange(value) {
				console.log('value',value)
				let checkedCount = value.length;//选中的项的总数
				this.mCheckAll = checkedCount === this.currentAddWuLiu.goods.length;//判断选中的项的个数是不是和所有项的个数
				
			},
			//点击添加物流弹窗上的确认按钮
			async addWuLiuOKBtn() {
				if(this.mCheckList.length==0){
					this.$message.error('请选择商品')
					return;
				}
				
				if (!this.addWuLiuByShippingName.trim()) {

					this.$message.error('请输入物流公司名称')
					return;
				}
				if (!this.addWuLiuByShippingNo.trim()) {
					this.$message.error('请输入物流单号')
					return;
				}

				this.loading = true;
				let res = await ajax('/order/express', 'POST', {
					order_id: this.currentAddWuLiu.id,
					order_goods_id:this.mCheckList,
					express_name: this.addWuLiuByShippingName,
					express_num: this.addWuLiuByShippingNo
				});
				const data = res.data.data;
				this.loading = false;
				this.$message({
					type: 'success',
					message: '成功!'
				});
				this.initData();
				this.isShowAddWuLiu = false;

			},

			//显示物流信息
			async showWuLiu(row) {
				this.loading = true;
				let res = await ajax('/hq/order/express', 'GET', {
					order_id: row.id
				});
				const express = res.data.data.express;
				this.loading = false;


				//没有物流
				if (!express) {
					this.$message.error('暂无物流信息')
					return;
				}


				this.currentWuLiu = express; //当前显示的物流数据
				this.isShowWuLiu = true; //是否显示物流信息
				console.log('this.isShowWuLiu', this.isShowWuLiu)

			},
			showOrderModal(list) {
				this.isShowOrderModal = true;
				this.currentOrderListObj = list;
			},

			handlePreView(url, width) {
				this.preView.imgUrl = url
				this.preView.show = true
				if (width) {
					this.preView.width = width
				}
			},
			modalOk() {
				this.modal.show = false
			},
			modalClose(isRefresh) {
				this.modal.show = false
				this.row2modal = {}
				if (isRefresh) {
					this.initData()
				}
			},
			handleSelect(e) {
				this.selectData = e;
			},


			show(row) {
				this.row2modal = _.cloneDeep(row)
				this.modal.show = true
			},
			add() {
				this.row2modal = {}
				this.modal.show = true
			},

			changePage(pageNumber) {
				this.tableData = []; //这种可以让滚动条回到顶部
				this.pageNumber = pageNumber
				this.initData()
			},

			changePageFX(pageNumber) {
				this.fanxianArr = []; //这种可以让滚动条回到顶部
				this.pageNumberFX = pageNumber
				this.fanxianList()
			},


			handleDelete(row) {
				this.delModal.guid = row.guid
				this.delModal.show = true
			},
			deleteOK() {
				this.loading = true
				let guid = this.delModal.guid
				api.del({
					guid
				}).then(res => {
					if (res.data.state && res.data.state === 'ok') {
						this.$Message.success('删除成功')
						this.initData()
					} else {
						this.$Message.error(res.data.msg)
					}
					this.delModal.guid = ''
					this.delModal.show = false
					this.loading = false
				}).catch(err => {
					this.loading = false
					this.$Message.error(err)
					this.delModal.show = false
					this.loading = false
				})
			},
			deleteCancel() {
				this.delModal.guid = ''
				this.delModal.show = false
			},
			exportExcel() {
				// this.$refs.tablesi.exportCsv({
				//   filename: `table-${(new Date()).valueOf()}.csv`
				//})
			},
			createTimeDateRange(v, w) {
				this.searchForm.createTimeStart = v[0]
				this.searchForm.createTimeEnd = v[1]
			},
			updateTimeDateRange(v, w) {
				this.searchForm.updateTimeStart = v[0]
				this.searchForm.updateTimeEnd = v[1]
			},
			/**
			 * 搜索
			 */
			handleSearch() {
				this.pageNumber = 1
				this.total = 0;
				this.initData()
			},

			/**
			 * 重置
			 */
			handleReset() {
				this.$refs.searchForm.resetFields()
				this.searchForm = {
					order_status: "",
					invoice_status: '',
					express_type:[]
				};

				this.pageNumber = 1
				this.total = 0;
				this.pageSize = 10
				this.tableData = []; //表格数据修改为空
				this.initData()
			},

		}
	}
</script>

<style scoped lang="scss">
	.tableTem ul {
		width: 100%;
		overflow: hidden;
		display: flex;
		flex-wrap: wrap;

	}

	.tableTem ul li {
		list-style: none;

		width: 110px;
		min-height: 60px;
		border-left: 1px solid #ededed;
		border-bottom: 1px solid #ededed;
		margin-bottom: -1px;
		display: flex;
		justify-content: end;
		align-items: center;
		flex-direction: column;
		padding: 3px;


	}

	>>>.el-table tbody tr:hover>td {
		background-color: transparent !important;
	}

	.tableTem .content {

		padding-top: 3px;
		font-size: 14px;

		font-weight: 600;
	}



	.tableTem .avatar img {
		border-radius: 50%;
		width: 60px;
		height: 60px;
	}

	.tableTem .avatar {
		/* height: 120px; */

		display: flex;
		justify-content: center;
		align-items: center;
	}

	.tableTem .dian {
		text-align: center;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		width: 100px;
	}

	.titleFont {
		font-size: 12px !important;
		flex-shrink: 0;
		line-height: 25px;
		color: rgb(136, 136, 136);
	}





	.sortLine {
		display: flex;
		align-items: center;
		min-height: 35px;
	}

	.sortItem {
		padding: 0 20px;
		height: 100%;
		color: rgb(156, 156, 156);
		text-align: center;
		line-height: 35px;
		cursor: pointer;
	}

	.sortItem:hover {
		background-color: #19be6b !important;
		color: #fff !important;
	}

	.sortLine .sortItem:last-child {
		border-right: none;
	}

	>>>.ivu-table-cell {
		padding-left: 0 !important;
		padding-right: 0 !important;
	}

	>>>.el-table .el-table-column--selection .cell {
		padding: 0 !important;
		padding-left: 20px !important;
	}
</style>
